import { render, staticRenderFns } from "./SupplierPortalDetailDialog.vue?vue&type=template&id=11ba2a42"
import script from "./SupplierPortalDetailDialog.vue?vue&type=script&lang=js"
export * from "./SupplierPortalDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports